import Lozenge from 'components/Tiles/Lozenge'
import moment from 'moment'
import { primaryColor } from 'styles/styleVariables'
import type { Prescriber } from 'types'
import { normalizeProviderType } from 'utils/prescriber'
import { ListRowLabel, ListRowValue, RXDataRow } from './StyledComponents'

type DemographicBlockType = {
  prescriber: Prescriber
  isVet: boolean
}

const getGenderString = (prescriber: Prescriber) => {
  let gender = prescriber?.gender

  if (!gender) {
    gender = prescriber?.npiDoc?.gender
  }

  if (gender === 'F') {
    return 'Female'
  } else if (gender === 'M') {
    return 'Male'
  }
  return ''
}

const getSuffix = (prescriber: Prescriber) => {
  if (prescriber.suffix) {
    return `, ${prescriber.suffix}`
  } else if (prescriber?.npiDoc?.credential) {
    const credential: string = prescriber.npiDoc.credential
    return `, ${normalizeProviderType(credential)}`
  }
  return ''
}

const DemographicBlock = ({ prescriber, isVet }: DemographicBlockType): JSX.Element => {
  return (
    <>
      <RXDataRow>
        <ListRowLabel>Name:</ListRowLabel>
        <ListRowValue>
          {prescriber.firstName} {prescriber.lastName}
          {getSuffix(prescriber)}
        </ListRowValue>
      </RXDataRow>
      {isVet && prescriber.npi ? (
        <RXDataRow>
          <ListRowLabel>NPI:</ListRowLabel>
          <ListRowValue>
            <ul>
              <li>{prescriber.npi}</li>
              <li>
                Expiration date:{' '}
                {prescriber?.npiDoc?.deactivationDate
                  ? moment(prescriber?.npiDoc?.deactivationDate).format('MM/DD/YYYY')
                  : `N/A`}
              </li>
            </ul>
            <Lozenge backgroundColor={primaryColor}>ACTIVE</Lozenge>
          </ListRowValue>
        </RXDataRow>
      ) : (
        ''
      )}
      <RXDataRow>
        <ListRowLabel>{isVet ? 'License #:' : 'NPI:'}</ListRowLabel>
        {isVet ? (
          <ListRowValue>{prescriber.stateLicense}</ListRowValue>
        ) : (
          <ListRowValue>
            <ul>
              <li>{prescriber.npi}</li>
              <li>
                Expiration date:{' '}
                {prescriber?.npiDoc?.deactivationDate
                  ? moment(prescriber?.npiDoc?.deactivationDate).format('MM/DD/YYYY')
                  : `N/A`}
              </li>
            </ul>
            <Lozenge backgroundColor={primaryColor}>ACTIVE</Lozenge>
          </ListRowValue>
        )}
      </RXDataRow>
      {isVet ? (
        ''
      ) : (
        <RXDataRow>
          <ListRowLabel>Gender:</ListRowLabel>
          <ListRowValue>{getGenderString(prescriber)}</ListRowValue>
        </RXDataRow>
      )}
      <RXDataRow>
        <ListRowLabel>Credential:</ListRowLabel>
        <ListRowValue>
          {prescriber?.suffix
            ? normalizeProviderType(prescriber.suffix)
            : prescriber?.npiDoc?.credential
            ? normalizeProviderType(prescriber.npiDoc.credential)
            : 'unknown'}
        </ListRowValue>
      </RXDataRow>
      <RXDataRow>
        <ListRowLabel>DEA:</ListRowLabel>
        <ListRowValue style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {prescriber.dea || 'Not provided'}
        </ListRowValue>
      </RXDataRow>
    </>
  )
}

export default DemographicBlock
